<div class="col-12 pl-0 mb-3">
  <a (click)="back.emit()" class="link-secondary font-default cursor-pointer" data-zid="bezugsrecht-back-link">
    <svg class="icon icon-21"><use xlink:href="/assets/img/svgs/svgset.svg#arrow-left" /></svg>
    {{ label | transloco }}
  </a>
</div>
